import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useReports } from '../hooks/useReports'
import { ReportCard } from '../components/ReportCard'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { ErrorAlert } from '../components/ErrorAlert'

export function Dashboard() {
  const { loading, error, getReports } = useReports()
  const [reports, setReports] = useState([])

  useEffect(() => {
    loadReports()
  }, [])

  async function loadReports() {
    try {
      const data = await getReports()
      setReports(data.reports || [])
    } catch (err) {
      console.error('Failed to load reports:', err)
    }
  }

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 sm:mb-8">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Your Reports</h1>
          <p className="mt-1 sm:mt-2 text-sm sm:text-base text-gray-600">
            Manage your scheduled AI-powered reports
          </p>
        </div>
        <Link
          to="/reports/new"
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-5 rounded-lg transition-colors text-center sm:whitespace-nowrap"
        >
          Create New Report
        </Link>
      </div>

      {error && (
        <ErrorAlert message={error} />
      )}

      {loading ? (
        <LoadingSpinner message="Loading reports..." />
      ) : reports.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg border-2 border-dashed border-gray-300">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 className="mt-2 text-sm font-semibold text-gray-900">No reports</h3>
          <p className="mt-1 text-sm text-gray-500">Get started by creating your first report.</p>
          <div className="mt-6">
            <Link
              to="/reports/new"
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              Create New Report
            </Link>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reports.map(report => (
            <ReportCard key={report.report_id} report={report} />
          ))}
        </div>
      )}
    </div>
  )
}
